"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var propTypes = {
  children: _propTypes.default.node,
  useCapture: _propTypes.default.bool,
  onOutsideClick: _propTypes.default.func
};
var defaultProps = {
  children: /*#__PURE__*/_react.default.createElement("span", null),
  useCapture: true,
  onOutsideClick: function onOutsideClick() {}
};

var OutsideClickHandler = /*#__PURE__*/function (_React$Component) {
  _inherits(OutsideClickHandler, _React$Component);

  var _super = _createSuper(OutsideClickHandler);

  function OutsideClickHandler(props) {
    var _this;

    _classCallCheck(this, OutsideClickHandler);

    _this = _super.call(this, props);
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OutsideClickHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (document.addEventListener) {
        document.addEventListener('click', this.handleOutsideClick, this.props.useCapture);
      } else {
        document.attachEvent('onclick', this.handleOutsideClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (document.removeEventListener) {
        document.removeEventListener('click', this.handleOutsideClick, this.props.useCapture);
      } else {
        document.detachEvent('onclick', this.handleOutsideClick);
      }
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(e) {
      var isDescendantOfRoot = this.childNode.contains(e.target);

      if (!isDescendantOfRoot) {
        this.props.onOutsideClick(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(_ref) {
          _this2.childNode = _ref;
        }
      }, this.props.children);
    }
  }]);

  return OutsideClickHandler;
}(_react.default.Component);

OutsideClickHandler.propTypes = propTypes;
OutsideClickHandler.defaultProps = defaultProps;
var _default = OutsideClickHandler;
exports.default = _default;